/**
 * Dispatch a custom event to `window` object.
 */
export function dispatchWindowEvent (eventName, data) {
    var event = document.createEvent('CustomEvent')
    event.initCustomEvent(eventName, true, true, data)
    window.dispatchEvent(event)
}



//////////////////
// WEBPACK FOOTER
// ./src/core/src/utils/event.js
// module id = 32
// module chunks = 1